import React from 'react';
import styles from './SelectCommon.module.scss';
import Select, { SelectProps } from './Select';
import { ReactComponent as DropdownIcon } from '../../../assets/icons/arrow-dropdown-dark.svg';

function SelectCommon(props: SelectProps) {
  return (
    <Select inputClassName={styles.selectCommonInput} dropDownIcon={<DropdownIcon className={styles.selectCommonIcon} />} {...props} />
  );
}

export default SelectCommon;
